import React, { Component } from 'react';
import TopMenu from './Screens/TopMenu/TopMenuContainer';

const App = ({ children }) => {
   return (
   <div>
       <div>
        <TopMenu />
       </div>
       <div>
          {children}
       </div>
    </div>
    );
}

export default App;


// WEBPACK FOOTER //
// ./Portico/App/App.js